import _ from 'lodash';

export default function lastNotesAreAll(lastNotes, amount, noteIndex) {
  if (!lastNotes.length) return false;
  return _.every(
    _.takeRight(lastNotes, amount),
    n => n.noteIndex === noteIndex
  )
}



// WEBPACK FOOTER //
// ./src/lib/lastNotesAreAll.js